// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  receiptId: __t.u64().primaryKey().name("receipt_id"),
  identity: __t.identity(),
  requestId: __t.string().name("request_id"),
  fingerprint: __t.string(),
  kind: __t.string(),
  disposition: __t.string(),
  listingId: __t.u64().name("listing_id"),
  qty: __t.u32(),
  atTick: __t.u64().name("at_tick"),
  at: __t.timestamp(),
});
